<emm-management-layout>
  <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
  <emm-search-filter
    [addDialog]="true"
    [displaySearchWithOptions]="false"
    [fields]="fields$ | async"
    [isAdminOrAuthor]="(this.isAdmin || this.isAuthor) && !isMMSAuthor"
    [isSuperAdmin]="this.isSuperAdmin"
    layout-center-header
    (add)="openCreateConsumerCategoryDialog()"
    (filter)="onFilter($event)"
  ></emm-search-filter>
  <emm-generic-items-tree
    [contextMenuActions]="consumerManagerContextMenuActions"
    [disableContextActions]="false"
    [disableDefaultOnMove]="true"
    [items]="nodes$ | async"
    layout-center-content
    [options]="options"
    [readonly]="(isReadOnly$ | async) || isMMSAuthor"
    [isMmsAuthorOnly]="isMMSAuthor"
    [showLockedIndicator]="true"
  ></emm-generic-items-tree>
  @if ((selectedConsumerInfo | async); as item) {
    <emm-management-attributes-header
      layout-right-header
      [name]="item.name"
      [tag]="item.tag"
      [description]="item.description"
    ></emm-management-attributes-header>
  }
  @if ((selectedConsumerInfo | async) && selectedNode) {
    <emm-consumer-manager-form
      #form
      layout-right-content
      [selectedConsumerInfo]="selectedConsumerInfo | async"
      [node] = "selectedNode$ | async"
      [isSuperAdmin]="isSuperAdmin"
      [isAdmin]="isAdmin"
      (toggleButtons)="toggleButtons()"
    ></emm-consumer-manager-form>
  }
  @if ((selectedConsumerInfo | async) && !isMMSAuthor) {
    <emm-management-attributes-footer
      [disableCancel]="!consumerManagerForm?.hasChanges()"
      [disableUpdate]="!consumerManagerForm?.hasChanges()"
      layout-right-footer
      (cancel)="cancel()"
      (submit)="submit()"
      class="consumer-manager-footer"
    ></emm-management-attributes-footer>
  }
</emm-management-layout>
